module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-32-45-765.e8946264.mp4";